var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-button',{class:_vm.$style.button},[_c('icon',{class:_vm.$style.icon,attrs:{"name":"donate","width":"16","height":"16","fill":"primary"}}),_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(`${_vm.$t('donate', { amount: _vm.amount, currency: _vm.currency })} ${_vm.target}`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }